import { z } from 'zod';
import { createFlightEstimateSchema } from './create-estimate.schema.js';
import { estimateResponseVersionSchema } from './estimate-response.schema.js';
/**
 * Création « en un coup » d'une demande de devis vol ET de sa première réponse.
 *
 * Sert le parcours « Nouveau devis » du backoffice : l'agent part d'un PNR, peaufine
 * la demande et la réponse dans une seule page, puis valide. Les deux objets sont
 * créés dans la même transaction — pas de demande orpheline si l'agent abandonne.
 */
export const createFlightEstimateWithResponseSchema = z.object({
    estimate: createFlightEstimateSchema,
    version: estimateResponseVersionSchema,
});
